module.exports = __webpack_public_path__ + "static/media/24_A.77e15762.png";